export class Ssgcontractor {
        
        id : number;

        vendorRegistrationId : string;
        applicationNumber : string;
        applicationDate : Date;
        ssgNo : string;
        ssgId :string;
        description : string;
        typeofWork : string;

        woNo1 : string;
        woDate1 : Date;
        woValue1 : string;
        completionDate1 : Date;
        client1 : string;
        briefDescriptionWork1 : string;
        evaluatorsFigure1 : string;
        comments1 : string;

        woNo2 : string;
        woDate2 : Date;
        woValue2 : string;
        completionDate2 : Date;
        client2 : string;
        briefDescriptionWork2 : string;
        evaluatorsFigure2 : string;
        comments2 : string;

        woNo3 : string;
        woDate3 : Date;
        woValue3 : string;
        completionDate3 : Date;
        client3 : string;
        briefDescriptionWork3 : string;
        evaluatorsFigure3 : string;
        comments3 : string;

        totalValue : string;
        comments_Total_Value : string;
        modified : Date;
        created : Date;
        createdBy : string;
        modifiedBy : string;
}
